<template>
  <!-- 热血盲盒管理-随机房间记录 -->
  <div class="random_room-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item>
          <el-input
            v-model="query.user_id"
            placeholder="请输入用户id"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="query.boxId" placeholder="请输入盒子id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="query.start_time"
            type="datetime"
            placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          -
          <el-date-picker
            v-model="query.end_time"
            type="datetime"
            placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="handleExport"
            :loading="buttonLoading"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table :data="dataList" v-loading="loading">
        <el-table-column prop="boxId" label="盒子id" align="center">
        </el-table-column>
        <el-table-column prop="condition" label="参与条件" align="center">
          <template slot-scope="{ row }"> 充值满{{ row.condition }} </template>
        </el-table-column>
        <el-table-column prop="user_arr" label="参与用户" align="center">
          <template slot-scope="{ row }">
            参与用户：{{ row.user_arr }}
          </template>
        </el-table-column>
        <el-table-column prop="battle_time" label="出现日期" align="center">
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>
    <!-- 弹窗 -->
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'

export default {
  components: {
  },
  data() {
    return {
      replyVisible: false,//回复弹窗显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      switch_status: 0,//PK开关,0是关闭，1是打开
      query: {//查询条件
        page: 1,
        user_id: '',//用户id
        boxId: '',//工单类型
        start_time: '',//开始时间
        end_time: ''//结束时间
      },
      dialogInfo: undefined,//传给弹窗是数据
      dataList: undefined,//工单列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData(num) {
      if (num === 1) {
        //点击查询是还原下标
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData('battle_rand_room', params)
        .then(res => {
          this.dataList = res.data
          //设置底部导航条数据
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
    handleExport() {
      //保存任务
      //表单验证后发起请求
      this.buttonLoading = true
      let params = this.query

      http
        .post(
          api + 'battle_rand_export',
          { ...params },
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '随机房间信息.xlsx'
          })
        }).finally(() => {
          this.buttonLoading = false
        })
    },
  }

}
</script>
<style lang="less" scoped>
</style>